import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { IssueWebNotifications } from 'src/lib/fliko/models/defects/issue.base';
import { SubscribeComponent } from 'src/app/shared/classes/subscribe-component';
import { WebNotificationService } from 'src/app/shared/services/web-notification.service';
import { EventLogService } from 'src/app/view/event-log/services/event-log.service';
import { LocalStorageService } from 'src/app/shared/services/local-storage.service';
import { ContextDataService } from 'src/app/view/user-context/services/context.data-service';
import { RWDService } from 'src/app/view/user-context/services/rwd.service';
import { NavigationVM } from '../../navigation.component';

@Component({
  selector: 'app-navigation-entry[vm]',
  templateUrl: './navigation-entry.component.html',
  styleUrls: ['./navigation-entry.component.scss']
})
export class NavigationEntryComponent extends SubscribeComponent {
  @Input() vm!: NavigationVM;
  @Input() isSelected = false;
  @Input() collapsed = false;

  public showNtf = false;
  public ntfAmount = -1;

  constructor(
    public rwdService: RWDService,
    private router: Router,
    private eventLogService: EventLogService,
    private ctxDS: ContextDataService,
    private webNtfService: WebNotificationService,
    private localStorageSrv: LocalStorageService
  ) {
    super();
  }

  ngOnInit(): void {
    switch (this.vm.id) {
      case 'defect':
        this.initWebNtf(this.webNtfService.getDefectNtf$());
        break;
      case 'concierge':
        this.initWebNtf(this.webNtfService.getConciergeNtf$());
        break;
      case 'event':
        this.initEventLog();
        break;
    }
  }

  private initWebNtf(source$: Observable<IssueWebNotifications>) {
    this.showNtf = true;
    this.ntfAmount = 0;

    this.subscription$.add(source$.subscribe((ntf) => (this.ntfAmount = Object.keys(ntf ?? {}).length)));
  }

  private initEventLog() {
    // TODO: @Aandrzejmi this should NOT be in navigation
    // this.subscription$.add(this.ucs.getNewError$().subscribe((item) => (this.showNtf = !!item)));

    this.subscription$.add(
      this.ctxDS.currentEstate$
        .pipe(
          switchMap(
            (estate) => estate
              ? this.eventLogService.getEstateNewErrorEventLog$(estate.id).pipe(map((log) => { return { estate, log }; }))
              : of(null) // prettier-ignore
          )
        )
        .subscribe((data) => {
          const log = data?.log;
          const estate = data?.estate;
          if (!log?.length || !estate) return;

          const newLog = log[log.length - 1];
          this.localStorageSrv.errorLog.set(estate.id, JSON.stringify({ key: newLog.id, date: newLog.date }));
          // this.ucs.setNewErrorLog(newLog.id);
        })
    );
  }

  public navigateTo(link: string): void {
    this.router.navigate([link]);
    if (this.rwdService.isSmallDevice) this.rwdService.closeNavPanel();
  }
}
